import(/* webpackMode: "eager" */ "/app/packages/risk-dashboard/src/shared/components/page-wrapper/styled.ts");
import(/* webpackMode: "eager" */ "/app/packages/risk-dashboard/src/widgets/chart-list/chart-list.tsx");
import(/* webpackMode: "eager" */ "/app/packages/risk-dashboard/src/widgets/unknown-network/index.tsx")